import { Modal, message } from "antd";
import copy from "copy-to-clipboard";
import type { FC } from "react";
import { useState } from "react";
import Logo from "../../resources/annaLogo.svg";
import { onActivationKey } from "../a11y/activationKey";

import styles from "./Blocked.module.scss";

type BlockedProps = {
  name: string;
  accountNumber: string;
  sortCode: string;
};

export const Blocked: FC<BlockedProps> = ({ name, accountNumber, sortCode }) => {
  const [visible, toggleVisible] = useState(true);
  const handleClose = (): void => {
    toggleVisible(false);
  };
  const handleCopy = (): void => {
    copy(`${name}\nAccount number: ${accountNumber}\nSort code: ${sortCode}`);
    message.success("Bank details has been copied to clipboard");
  };

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.blocked}>
      <Modal className={styles.modal} open centered closable={false} footer={null} width={500}>
        <div className={styles.header}>
          <img src={Logo} alt="logo" />
        </div>
        <div className={styles.message}>
          Sorry, this payment paymentLink is unavailable right now, but you can copy their banks details and use them to
          pay another way.
        </div>
        <div className={styles.buttons}>
          <div
            className={styles.copyDetailsButton}
            role="button"
            tabIndex={0}
            onClick={handleCopy}
            onKeyDown={onActivationKey(handleCopy)}
          >
            Copy bank details
          </div>
          <div
            className={styles.closeButton}
            role="button"
            tabIndex={0}
            onClick={handleClose}
            onKeyDown={onActivationKey(handleClose)}
          >
            Close
          </div>
        </div>
      </Modal>
    </div>
  );
};
